import React from 'react';

import { Skeleton, Space } from '@sravni/react-design-system';

import commonStyles from '../../styles/common.module.scss';

export const CreateSkeleton = () => {
  return (
    <div className={commonStyles.blockWrapper} style={{ width: '100%' }}>
      <Skeleton>
        <Space>
          <Skeleton.Paragraph width={55} />
        </Space>
        <Space size={12} align={'start'}>
          <Skeleton.Avatar />
          <Space size={4} direction={'vertical'} align={'start'}>
            <Skeleton.Paragraph width={15} />
            <Skeleton.Paragraph width={15} />
          </Space>
          <Skeleton.Button />
        </Space>

        <Space size={4}>
          <Skeleton.Button style={{ width: '25%' }} />
          <Skeleton.Button style={{ width: '25%' }} />
          <Skeleton.Button style={{ width: '25%' }} />
          <Skeleton.Button style={{ width: '25%' }} />
        </Space>

        <Space size={4} direction={'vertical'}>
          <Skeleton.Paragraph width={15} />
          <Skeleton.Paragraph width={15} />
        </Space>
      </Skeleton>
    </div>
  );
};
